import { CssBaseline, ThemeProvider } from '@mui/material'
import { Toaster } from 'react-hot-toast'
import { useRoutes } from 'react-router-dom'

import { createCustomTheme } from './theme'
import { useAuth } from 'torqcloud-ui'
import { BreadcrumbsContextProvider } from '@components/Layout/Breadcrumbs'

import RTL from './components/layouts/RTL'
import SplashScreen from './components/SplashScreen'
import { OfflineNotification } from './components/OfflineNotification'
import { UpdateNotification } from './components/UpdateNotification'
import { useCrisp } from './hooks/useCrisp'
import useScrollReset from './hooks/useScrollReset'
import useSettings from './hooks/useSettings'
import './i18n'
import routes from './routes'
import { themesOptions } from './theme'
import { AppConfigProvider } from 'torqcloud-ui'
import { appConfig } from '@/config'
import { TitleManager } from './components/toolBuilder/TitleManager'
import RevisionConflictDialog from './components/revisionHistory/RevisionConflictDialog'

const App = () => {
  const content = useRoutes(routes)
  const { settings } = useSettings()
  const auth = useAuth()

  useCrisp()
  useScrollReset()

  const config = {
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    roundedCorners: settings.roundedCorners,
    theme: settings.theme,
  }

  const theme = createCustomTheme(config, themesOptions(config)[settings.theme])

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={settings.direction}>
        <BreadcrumbsContextProvider>
          <AppConfigProvider config={appConfig}>
            <CssBaseline />
            <TitleManager />
            <Toaster position="top-center" />
            <OfflineNotification />
            <UpdateNotification />
            <RevisionConflictDialog />
            {auth.isInitialized ? content : <SplashScreen />}
          </AppConfigProvider>
        </BreadcrumbsContextProvider>
      </RTL>
    </ThemeProvider>
  )
}

export default App
